import { StyleSheet, Text, View, FlatList, Modal, ActivityIndicator } from 'react-native'
import React from 'react'
import { ActionButton, LabledTextField } from '../SharedWidgets/LoginAndSignup'
import { useOtpSignIn } from './Store';
import { useFonts } from '@expo-google-fonts/poppins';
import { Poppins_700Bold } from '@expo-google-fonts/poppins';
import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { RootStackParamList } from '../../Types/uitypes';
import { navStack } from '../../Types/uitypes';
import CoupanItemView from '../CoupansScreen/widgets/CoupanItemView';
import OtpModalView from '../SharedWidgets/LoginAndSignup/OtpModalView';

export default function OtpSignIn() {

    const navigation = useNavigation<navStack>();

    const {
        email,
        setEmail,
        hideActivityIndicator,
        toggleActivityIndicator,
        sendOtp,
        coupans,
        otpValue,
        handleBuy,
        onOtpValueChange,
        handleVefrifyOtp,
        hideModal,
        loading,
        showModal,
        openModal,
        authed,

    } = useOtpSignIn();


    const [fontsLoaded] = useFonts({ Poppins_700Bold });
    if (!fontsLoaded) return null;

    async function handleAction() {
        sendOtp(() => {
            openModal()
        })
    }

    return (
        <View >

            {!authed && (
                <View style={styles.root}>
                    <View>
                        <Text style={{ fontFamily: 'Poppins_700Bold', fontSize: 24, textAlign: "center" }}>
                            Otp Based SignIn
                        </Text>

                        <Text style={{ fontFamily: 'Poppins_700Bold', fontSize: 14, textAlign: "center", color: "#343434" }}>
                            Enter An Email to get OTP!
                        </Text>
                    </View>

                    <LabledTextField
                        hint='Enter email'
                        title='Email'
                        value={email}
                        onValueChange={setEmail}
                    />

                    <ActionButton label='Send Otp' onClick={handleAction} />
                    {hideActivityIndicator ? (
                        <ActivityIndicator size="large" />
                    ) : (
                        null
                    )}


                    <Modal
                        visible={showModal}
                        transparent
                        animationType="slide"
                    >
                        <View style={styles.modalOverlay}>
                            <View style={styles.modalContainer}>
                                <OtpModalView
                                    value={otpValue}
                                    onValueChange={onOtpValueChange}
                                    handleVerifyOptp={handleVefrifyOtp}
                                    hideModel={hideModal}
                                    loading={hideActivityIndicator}
                                />
                            </View>
                        </View>
                    </Modal>
                </View>
            )}


            <FlatList
                data={coupans}
                keyExtractor={(item) => item.id.toString()}
                renderItem={({ item }) => <CoupanItemView item={item} onItemPress={() => handleBuy(item)} />}
                contentContainerStyle={styles.container}
                ListHeaderComponent={
                    authed ? (
                        <View>
                            <Text style={{ fontSize: 18, textAlign: "center" }}>
                                User-name: {email}
                            </Text>
                        </View>
                    ) : null
                }

            />

        </View>
    )
}



const styles = StyleSheet.create({
    root: {
        paddingHorizontal: 10,
        gap: 10
    },
    container: { padding: 16, gap: 10 },
    modalOverlay: {
        flex: 1,
        justifyContent: "flex-end", // push to bottom
        backgroundColor: "rgba(0,0,0,0.5)",
    },

    modalContainer: {
        height: "50%", // 👈 Half screen
        backgroundColor: "white",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 20,
    },
})